import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { doc, getDoc } from "firebase/firestore"
import { db } from "../services/firebase"
import "./Propuestas.css"

// ═══════════════════════════════════════════════════════════
// DATOS — Cupos aéreos
// ═══════════════════════════════════════════════════════════
const CUPOS_BUE = [
  { compania:"Flybondi", fechaIn:"12/03/2026", fechaOut:"19/03/2026", origen:"Buenos Aires", cupos:3  },
  { compania:"Flybondi", fechaIn:"07/04/2026", fechaOut:"14/04/2026", origen:"Buenos Aires", cupos:4  },
  { compania:"GOL",      fechaIn:"17/05/2026", fechaOut:"24/05/2026", origen:"Buenos Aires", cupos:2  },
  { compania:"GOL",      fechaIn:"10/06/2026", fechaOut:"17/06/2026", origen:"Buenos Aires", cupos:10 },
  { compania:"GOL",      fechaIn:"12/07/2026", fechaOut:"19/07/2026", origen:"Buenos Aires", cupos:10 },
  { compania:"GOL",      fechaIn:"14/08/2026", fechaOut:"21/08/2026", origen:"Buenos Aires", cupos:6  },
  { compania:"GOL",      fechaIn:"09/09/2026", fechaOut:"16/09/2026", origen:"Buenos Aires", cupos:10 },
]
const CUPOS_CBA = [
  { compania:"GOL", fechaIn:"05/05/2026", fechaOut:"13/05/2026", origen:"Córdoba", cupos:5  },
  { compania:"GOL", fechaIn:"11/06/2026", fechaOut:"19/06/2026", origen:"Córdoba", cupos:10 },
  { compania:"GOL", fechaIn:"13/08/2026", fechaOut:"21/08/2026", origen:"Córdoba", cupos:10 },
  { compania:"GOL", fechaIn:"17/09/2026", fechaOut:"25/09/2026", origen:"Córdoba", cupos:5  },
]

// ═══════════════════════════════════════════════════════════
// DATOS — Puntos
// ═══════════════════════════════════════════════════════════
const CANJE = [
  { puntos:50,  descuento:10  },
  { puntos:100, descuento:25  },
  { puntos:350, descuento:100 },
]
function calcularDescuento(pts) {
  let desc = 0, rest = pts
  ;[...CANJE].sort((a,b)=>b.puntos-a.puntos).forEach(c=>{
    const v=Math.floor(rest/c.puntos); desc+=v*c.descuento; rest-=v*c.puntos
  })
  return desc
}
function ptsCliente(c) {
  if (!c) return 0
  return (c.puntos_aporte||0)+(c.puntos_feedback||0)+(c.puntos_referidos||0)
        +(c.puntos_compra_ref||0)+(c.puntos_cumpleanos||0)-(c.puntos_usados||0)
}

// ═══════════════════════════════════════════════════════════
// DATOS — Calculador
// ═══════════════════════════════════════════════════════════
const AEREOS = {
  "rio-buzios":      { "Buenos Aires":778, "Córdoba":953, "Rosario":991, "Mendoza":1050 },
  "maceio-maragogi": { "Buenos Aires":1230,"Córdoba":1363,"Rosario":1389,"Mendoza":1339 },
}
const TRASLADOS    = { "rio-buzios":144, "maceio-maragogi":243 }
const NOCHES_DEF   = {
  "rio-buzios":      { "Búzios":4, "Río de Janeiro":3 },
  "maceio-maragogi": { "Maragogi":4, "Maceió":4 },
}

const TIER_CONFIG = {
  economico:  { label:"🎒 Económico",  color:"#3b82f6" },
  intermedio: { label:"⚖️ Intermedio", color:"#10b981" },
  exclusivo:  { label:"👑 Exclusivo",  color:"#c9a84c" },
}

// Hoteles del calculador con fotos
const CALC_HOTELES = {
  "rio-buzios": {
    "Búzios": [
      { nombre:"Kybalion",            tier:"economico",  precioPorNoche:48,  zona:"Tartaruga",      foto:"/fotos/rio-buzios/kybalion/foto1.jpg" },
      { nombre:"Dos Coqueiros",       tier:"economico",  precioPorNoche:42,  zona:"Tartaruga",      foto:"/fotos/rio-buzios/dos-coqueiros/foto1.jpg" },
      { nombre:"Da Ferradura",        tier:"intermedio", precioPorNoche:64,  zona:"Ferradura",      foto:"/fotos/rio-buzios/da-ferradura/foto1.jpg" },
      { nombre:"Casa Centro Búzios",  tier:"intermedio", precioPorNoche:66,  zona:"Centro",         foto:"/fotos/rio-buzios/casa-centro/foto1.jpg" },
      { nombre:"Mar Joao Fernandes",  tier:"exclusivo",  precioPorNoche:73,  zona:"Joao Fernandes", foto:"/fotos/rio-buzios/mar-joao/foto1.jpg" },
      { nombre:"Casagrande Boutique", tier:"exclusivo",  precioPorNoche:84,  zona:"Joao Fernandes", foto:"/fotos/rio-buzios/casagrande/foto1.jpg" },
    ],
    "Río de Janeiro": [
      { nombre:"Rede Andrade Hotel",  tier:"economico",  precioPorNoche:81,  zona:"Copacabana",     foto:"/fotos/rio-buzios/rede-andrade/foto1.jpg" },
      { nombre:"Royalty Copacabana",  tier:"intermedio", precioPorNoche:94,  zona:"Copacabana",     foto:"/fotos/rio-buzios/royalty-copacabana/foto1.jpg" },
      { nombre:"Majestic Río Palace", tier:"intermedio", precioPorNoche:90,  zona:"Copacabana",     foto:"/fotos/rio-buzios/majestic-rio/foto1.jpg" },
      { nombre:"Savoy Othon",         tier:"exclusivo",  precioPorNoche:110, zona:"Copacabana",     foto:"/fotos/rio-buzios/savoy-othon/foto1.jpg" },
      { nombre:"Rio Othon Palace",    tier:"exclusivo",  precioPorNoche:203, zona:"Copacabana",     foto:"/fotos/rio-buzios/rio-othon-palace/foto1.jpg" },
    ],
  },
  "maceio-maragogi": {
    "Maragogi": [
      { nombre:"Maragolfinho",       tier:"intermedio", precioPorNoche:56, zona:"Maragogi",       foto:"/fotos/maceio-maragogi/maragolfinho/foto1.jpg" },
      { nombre:"Sete Mares",         tier:"intermedio", precioPorNoche:60, zona:"Praia do Camacho",foto:"/fotos/maceio-maragogi/sete-mares/foto1.jpg" },
      { nombre:"Pousada Taieiras",   tier:"exclusivo",  precioPorNoche:80, zona:"Maragogi",       foto:"/fotos/maceio-maragogi/pousada-taieiras/foto1.jpg" },
      { nombre:"Pousada Tartaruga",  tier:"exclusivo",  precioPorNoche:60, zona:"Maragogi",       foto:"/fotos/maceio-maragogi/pousada-tartaruga/foto1.jpg" },
    ],
    "Maceió": [
      { nombre:"San Marino Suite",      tier:"intermedio", precioPorNoche:95, zona:"Ponta Verde", foto:"/fotos/maceio-maragogi/san-marino/foto1.jpg" },
      { nombre:"Hilton Garden Inn",     tier:"intermedio", precioPorNoche:90, zona:"Pajuçara",    foto:"/fotos/maceio-maragogi/hilton-garden/foto1.jpg" },
      { nombre:"Ritz Suites Boutique",  tier:"exclusivo",  precioPorNoche:89, zona:"Jatiúca",     foto:"/fotos/maceio-maragogi/ritz-suites/foto1.jpg" },
      { nombre:"Slim Pajuçara",         tier:"exclusivo",  precioPorNoche:80, zona:"Pajuçara",    foto:"/fotos/maceio-maragogi/slim-pajucara/foto1.jpg" },
    ],
  },
}

// ═══════════════════════════════════════════════════════════
// DATOS — Hoteles info + fotos (para la sección explorar)
// ═══════════════════════════════════════════════════════════
const HOTELES = {
  "rio-buzios": [
    { id:"economico", label:"🎒 Económico", desc:"Lo esencial, sin sacrificar experiencia",
      ciudades:[
        { ciudad:"Búzios", zonas:["tartaruga"], hoteles:[
          { nombre:"Kybalion",       zona:"Tartaruga", zonaId:"tartaruga", amenities:[], precioPorNoche:48,
            desc:"Sobre la avenida principal, muy bien ubicado. Buena atención y confort.",
            fotos:["/fotos/rio-buzios/kybalion/foto1.jpg","/fotos/rio-buzios/kybalion/foto2.jpg"] },
          { nombre:"Dos Coqueiros",  zona:"Tartaruga", zonaId:"tartaruga", amenities:["🏊 Pileta"], precioPorNoche:42,
            desc:"Ambiente tranquilo y familiar. Buena base para explorar Búzios.",
            fotos:["/fotos/rio-buzios/dos-coqueiros/foto1.jpg","/fotos/rio-buzios/dos-coqueiros/foto2.jpg"] },
        ]},
        { ciudad:"Río de Janeiro", zonas:[], hoteles:[
          { nombre:"Rede Andrade Hotel", zona:"Copacabana", zonaId:null, amenities:[], precioPorNoche:81,
            desc:"A 2 cuadras de Copacabana. Ideal para conocer Río en profundidad.",
            fotos:["/fotos/rio-buzios/rede-andrade/foto1.jpg","/fotos/rio-buzios/rede-andrade/foto2.jpg"] },
        ]},
      ]},
    { id:"intermedio", label:"⚖️ Intermedio", desc:"La mejor relación precio-calidad",
      ciudades:[
        { ciudad:"Búzios", zonas:["ferradura","centro"], hoteles:[
          { nombre:"Da Ferradura",       zona:"Ferradura", zonaId:"ferradura", amenities:["🏊 Pileta"], precioPorNoche:64,
            desc:"La mejor playa de Búzios a pasos del hotel. Para pasar el día sin moverse.",
            fotos:["/fotos/rio-buzios/da-ferradura/foto1.jpg","/fotos/rio-buzios/da-ferradura/foto2.jpg"] },
          { nombre:"Casa Centro Búzios", zona:"Centro",   zonaId:"centro",    amenities:[], precioPorNoche:66,
            desc:"En el corazón de Búzios. Vida nocturna, restaurantes y centro histórico.",
            fotos:["/fotos/rio-buzios/casa-centro/foto1.jpg","/fotos/rio-buzios/casa-centro/foto2.jpg"] },
        ]},
        { ciudad:"Río de Janeiro", zonas:[], hoteles:[
          { nombre:"Royalty Copacabana",  zona:"Copacabana", zonaId:null, amenities:["🏊 Pileta","💪 Gimnasio","🧖 Sauna"], precioPorNoche:94,
            desc:"Pileta en la terraza con vista panorámica, gimnasio y sauna.",
            fotos:["/fotos/rio-buzios/royalty-copacabana/foto1.jpg","/fotos/rio-buzios/royalty-copacabana/foto2.jpg"] },
          { nombre:"Majestic Río Palace", zona:"Copacabana", zonaId:null, amenities:["🏊 Pileta","💪 Gimnasio","🧖 Sauna"], precioPorNoche:90,
            desc:"Con pileta, gimnasio y sauna. Excelente relación precio-calidad.",
            fotos:["/fotos/rio-buzios/majestic-rio/foto1.jpg","/fotos/rio-buzios/majestic-rio/foto2.jpg"] },
        ]},
      ]},
    { id:"exclusivo", label:"👑 Exclusivo", desc:"La experiencia completa, sin compromisos",
      ciudades:[
        { ciudad:"Búzios", zonas:["joao"], hoteles:[
          { nombre:"Mar Joao Fernandes",  zona:"Joao Fernandes", zonaId:"joao", amenities:["🏊 Pileta"], precioPorNoche:73,
            desc:"A 2 cuadras de la mejor playa privada de Búzios. Zona premium, lejos del ruido.",
            fotos:["/fotos/rio-buzios/mar-joao/foto1.jpg","/fotos/rio-buzios/mar-joao/foto2.jpg"] },
          { nombre:"Casagrande Boutique", zona:"Joao Fernandes", zonaId:"joao", amenities:["🏊 Pileta"], precioPorNoche:84,
            desc:"A una cuadra de la playa. El nivel boutique más alto de Búzios.",
            fotos:["/fotos/rio-buzios/casagrande/foto1.jpg","/fotos/rio-buzios/casagrande/foto2.jpg"] },
        ]},
        { ciudad:"Río de Janeiro", zonas:[], hoteles:[
          { nombre:"Savoy Othon",      zona:"Copacabana", zonaId:null, amenities:["💪 Gimnasio","🎱 Mesa de pool"], precioPorNoche:110,
            desc:"A 2 cuadras de la playa. Primer nivel de la cadena Othon.",
            fotos:["/fotos/rio-buzios/savoy-othon/foto1.jpg","/fotos/rio-buzios/savoy-othon/foto2.jpg"] },
          { nombre:"Rio Othon Palace",  zona:"Copacabana", zonaId:null, amenities:["🏊 Pileta","💪 Gimnasio","🌊 Vista al mar"], precioPorNoche:203,
            desc:"Frente a la playa. Pileta, vistas al mar. El mejor hotel de Copacabana.",
            fotos:["/fotos/rio-buzios/rio-othon-palace/foto1.jpg","/fotos/rio-buzios/rio-othon-palace/foto2.jpg"] },
        ]},
      ]},
  ],
  "maceio-maragogi": [
    { id:"intermedio", label:"⚖️ Intermedio", desc:"La mejor relación precio-calidad",
      ciudades:[
        { ciudad:"Maragogi", zonas:[], hoteles:[
          { nombre:"Sete Mares",    zona:"Praia do Camacho", zonaId:null, amenities:[], precioPorNoche:60,
            desc:"A 1 cuadra de la playa. Excelente base para explorar las piscinas naturales.",
            fotos:["/fotos/maceio-maragogi/sete-mares/foto1.jpg","/fotos/maceio-maragogi/sete-mares/foto2.jpg"] },
          { nombre:"Maragolfinho", zona:"Maragogi",           zonaId:null, amenities:["🏊 Pileta"], precioPorNoche:56,
            desc:"A 3 cuadras de la playa. Entorno tranquilo, ideal para descansar.",
            fotos:["/fotos/maceio-maragogi/maragolfinho/foto1.jpg","/fotos/maceio-maragogi/maragolfinho/foto2.jpg"] },
        ]},
        { ciudad:"Maceió", zonas:[], hoteles:[
          { nombre:"San Marino Suite",  zona:"Ponta Verde", zonaId:null, amenities:["🏊 Pileta","💪 Gimnasio","🍹 Bar"], precioPorNoche:95,
            desc:"A 2 cuadras de la playa de Ponta Verde. Zona tranquila con toda la comodidad.",
            fotos:["/fotos/maceio-maragogi/san-marino/foto1.jpg","/fotos/maceio-maragogi/san-marino/foto2.jpg"] },
          { nombre:"Hilton Garden Inn", zona:"Pajuçara",    zonaId:null, amenities:["🏊 Pileta"], precioPorNoche:90,
            desc:"A 2 cuadras de Pajuçara. Estándares internacionales garantizados.",
            fotos:["/fotos/maceio-maragogi/hilton-garden/foto1.jpg","/fotos/maceio-maragogi/hilton-garden/foto2.jpg"] },
        ]},
      ]},
    { id:"exclusivo", label:"👑 Exclusivo", desc:"La experiencia completa, sin compromisos",
      ciudades:[
        { ciudad:"Maragogi", zonas:[], hoteles:[
          { nombre:"Pousada Taieiras",  zona:"Maragogi", zonaId:null, amenities:["🏊 Pileta","🔥 Parrilla"], precioPorNoche:80,
            desc:"A 2 cuadras de la playa. Con pileta y parrilla. Ambiente exclusivo.",
            fotos:["/fotos/maceio-maragogi/pousada-taieiras/foto1.jpg","/fotos/maceio-maragogi/pousada-taieiras/foto2.jpg"] },
          { nombre:"Pousada Tartaruga", zona:"Maragogi", zonaId:null, amenities:["🏊 Pileta","🌊 Vista al mar"], precioPorNoche:60,
            desc:"A una cuadra de la playa. Con pileta y vista al mar. La posada más top de Maragogi.",
            fotos:["/fotos/maceio-maragogi/pousada-tartaruga/foto1.jpg","/fotos/maceio-maragogi/pousada-tartaruga/foto2.jpg"] },
        ]},
        { ciudad:"Maceió", zonas:[], hoteles:[
          { nombre:"Slim Pajuçara",        zona:"Pajuçara", zonaId:null, amenities:["🏊 Pileta"], precioPorNoche:80,
            desc:"A 1 cuadra de la playa más calma de Maceió. Alto confort.",
            fotos:["/fotos/maceio-maragogi/slim-pajucara/foto1.jpg","/fotos/maceio-maragogi/slim-pajucara/foto2.jpg"] },
          { nombre:"Ritz Suites Boutique", zona:"Jatiúca",  zonaId:null, amenities:["🏊 Pileta","💪 Gimnasio","🍹 Bar"], precioPorNoche:89,
            desc:"Frente a la playa de Jatiúca. Con pileta, gimnasio y bar. El nivel más alto de Maceió.",
            fotos:["/fotos/maceio-maragogi/ritz-suites/foto1.jpg","/fotos/maceio-maragogi/ritz-suites/foto2.jpg"] },
        ]},
      ]},
  ],
}

// ═══════════════════════════════════════════════════════════
// DATOS — Ambiente, flujo, incluye, zonas, destinos
// ═══════════════════════════════════════════════════════════
const FOTOS_AMBIENTE = {
  "rio-buzios": {
    "Búzios":         [1,2,3,4,5].map(n=>`/fotos/rio-buzios/ambiente-buzios/foto${n}.jpg`),
    "Río de Janeiro": [1,2,3,4,5].map(n=>`/fotos/rio-buzios/ambiente-rio/foto${n}.jpg`),
  },
  "maceio-maragogi": {
    "Maragogi": [1,2,3,4,5].map(n=>`/fotos/maceio-maragogi/ambiente-maragogi/foto${n}.jpg`),
    "Maceió":   [1,2,3,4,5].map(n=>`/fotos/maceio-maragogi/ambiente-maceio/foto${n}.jpg`),
  },
}
const FLUJO_VIAJE = {
  "rio-buzios": [
    { icono:"✈️", titulo:"Salida desde tu ciudad",  desc:"Tomás el vuelo directo a Río de Janeiro." },
    { icono:"🚐", titulo:"Transfer a Búzios",       desc:"Te esperamos en el aeropuerto. 3 horas de ruta costera hasta Búzios." },
    { icono:"🌊", titulo:"Noches en Búzios",        desc:"Días de playa. Opcionalmente: escuna, Arraial do Cabo, Cabo Frio." },
    { icono:"🏙️", titulo:"Transfer a Río",          desc:"Te buscamos en el hotel y te llevamos directo a Río." },
    { icono:"🗿", titulo:"Días en Río de Janeiro",  desc:"Cristo Redentor, Pan de Azúcar, Ipanema. A tu ritmo." },
    { icono:"🛫", titulo:"Vuelta a casa",            desc:"Transfer al aeropuerto y regreso." },
  ],
  "maceio-maragogi": [
    { icono:"✈️", titulo:"Salida desde tu ciudad",  desc:"Tomás el vuelo hacia Maceió, capital de Alagoas." },
    { icono:"🚐", titulo:"Transfer a Maragogi",     desc:"Te esperamos en el aeropuerto y te llevamos directo a Maragogi." },
    { icono:"🏝️", titulo:"Noches en Maragogi",      desc:"Las piscinas naturales más impresionantes del mundo. Aguas turquesas." },
    { icono:"🌃", titulo:"Transfer a Maceió",       desc:"Te buscamos en el hotel y te trasladamos a Maceió." },
    { icono:"🌴", titulo:"Días en Maceió",          desc:"Playas calmas, gastronomía nordestina. Opcionalmente: vida nocturna." },
    { icono:"🛫", titulo:"Vuelta a casa",            desc:"Transfer al aeropuerto y regreso." },
  ],
}
const ZONAS_BUZIOS = [
  { id:"tartaruga", label:"Tartaruga",      desc:"Aguas calmas, zona estratégica. Buena para moverse por toda Búzios." },
  { id:"centro",    label:"Centro",         desc:"La movida nocturna: bares, restaurantes, tiendas y vida hasta tarde." },
  { id:"ferradura", label:"Ferradura",      desc:"La mejor playa de Búzios. Bahía protegida con aguas turquesas." },
  { id:"joao",      label:"Joao Fernandes", desc:"Zona premium y tranquila. Las mejores posadas y una playa impecable." },
]
const INCLUYE = [
  { icono:"✈️", label:"Aéreos ida y vuelta",    sub:"Desde tu ciudad" },
  { icono:"🛏️", label:"Hospedaje Completo",     sub:"Desayuno incluido" },
  { icono:"🚐", label:"Traslados Internos",      sub:"Aeropuerto, entre ciudades" },
  { icono:"💬", label:"Comunicación 24 hs",      sub:"Con Sergio siempre" },
  { icono:"📋", label:"Organización Completa",   sub:"Olvidate de problemas administrativos" },
  { icono:"🛟", label:"Asistencia Opcional",     sub:"Durante todo el viaje" },
]
const DESTINOS = [
  {
    id:"rio-buzios", nombre:"Río de Janeiro + Búzios",
    emoji:"🌊", region:"Brasil",
    descripcion:"La combinación perfecta: la energía de Río y la tranquilidad de Búzios. Playas de película, gastronomía increíble y paisajes que no olvidás más.",
    videoId:"9hPaL3E8Vq4", precioDesde:600,
    temporada:"Abril – Junio · Agosto – Noviembre",
    cuposBue:CUPOS_BUE, cuposCba:CUPOS_CBA, tierDefault:"economico",
  },
  {
    id:"maceio-maragogi", nombre:"Maceió + Maragogi",
    emoji:"🏝️", region:"Brasil · Nordeste",
    descripcion:"Las piscinas naturales más impresionantes del mundo. Aguas turquesas, arena blanca y el nordeste brasileño en su estado más puro.",
    videoId:"BAeLwSRUFwY", precioDesde:1100,
    temporada:"Abril – Junio · Agosto – Noviembre",
    cuposBue:null, cuposCba:null, tierDefault:"intermedio",
  },
]

// ═══════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════
const WspIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{flexShrink:0}}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.532 5.858L.057 23.572a.5.5 0 0 0 .614.614l5.714-1.474A11.935 11.935 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.95 0-3.77-.502-5.348-1.38l-.372-.21-3.867.997.997-3.867-.21-.372A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
  </svg>
)

function BadgeCupos({ cupos }) {
  if (cupos <= 0) return <span className="prop-badge prop-badge--agotado">✕ Agotado</span>
  if (cupos <= 3) return <span className="prop-badge prop-badge--urgente">🔥 ¡Solo {cupos}!</span>
  return <span className="prop-badge prop-badge--ok">✓ {cupos}</span>
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Barra de urgencia de cupos (encima del todo)
// ═══════════════════════════════════════════════════════════
function BarraUrgencia({ destino }) {
  const [expandida, setExpandida] = useState(false)
  const todosLosCupos = [...(destino.cuposBue||[]), ...(destino.cuposCba||[])]
    .filter(c => c.cupos > 0)

  if (!todosLosCupos.length) return (
    <div className="prop-urgencia prop-urgencia--sin-cupos">
      <span>💬 Consultá disponibilidad de fechas directamente con Sergio</span>
      <a href="https://wa.me/5491125603574?text=Hola Sergio! Consulto disponibilidad para Maceió + Maragogi."
        target="_blank" rel="noreferrer" className="prop-urgencia__cta">Consultar →</a>
    </div>
  )

  const proximos = todosLosCupos.slice(0, 3)
  const urgentes = todosLosCupos.filter(c => c.cupos <= 3)

  return (
    <div className={"prop-urgencia" + (urgentes.length ? " prop-urgencia--alerta" : "")}>
      <div className="prop-urgencia__row">
        <div className="prop-urgencia__izq">
          {urgentes.length > 0
            ? <span className="prop-urgencia__titulo">🔥 ¡Quedan cupos limitados!</span>
            : <span className="prop-urgencia__titulo">🗓️ Próximos cupos disponibles</span>
          }
          <div className="prop-urgencia__fechas">
            {proximos.map((c,i) => (
              <div key={i} className="prop-urgencia__fecha-item">
                <span className="prop-urgencia__fecha-texto">{c.fechaIn} – {c.fechaOut}</span>
                <span className="prop-urgencia__fecha-origen">{c.origen}</span>
                <BadgeCupos cupos={c.cupos} />
              </div>
            ))}
          </div>
        </div>
        {todosLosCupos.length > 3 && (
          <button className="prop-urgencia__toggle" onClick={()=>setExpandida(p=>!p)}>
            {expandida ? "Ocultar ▲" : `Ver todos (${todosLosCupos.length}) ▼`}
          </button>
        )}
      </div>
      {expandida && (
        <div className="prop-urgencia__todos">
          {todosLosCupos.slice(3).map((c,i) => (
            <div key={i} className="prop-urgencia__fecha-item">
              <span className="prop-urgencia__fecha-texto">{c.fechaIn} – {c.fechaOut}</span>
              <span className="prop-urgencia__fecha-origen">{c.origen}</span>
              <BadgeCupos cupos={c.cupos} />
            </div>
          ))}
        </div>
      )}
      <div className="prop-urgencia__reserva">
        Reservá tu lugar con solo <strong>$100 USD</strong>
      </div>
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Video lazy
// ═══════════════════════════════════════════════════════════
function VideoShort({ videoId }) {
  const [activo, setActivo] = useState(false)
  return (
    <div className="prop-video" onClick={() => !activo && setActivo(true)}>
      {activo ? (
        <iframe src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} title="Video destino"
          frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen style={{width:"100%",height:"100%",border:"none",borderRadius:"14px"}} />
      ) : (
        <>
          <img src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`} alt="Ver video"
            className="prop-video__thumb" loading="lazy" />
          <div className="prop-video__overlay">
            <div className="prop-video__play">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>
            </div>
            <span className="prop-video__label">Ver video del destino</span>
          </div>
        </>
      )}
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Lightbox
// ═══════════════════════════════════════════════════════════
function Lightbox({ hotel, onClose }) {
  const [idx, setIdx] = useState(0)
  useEffect(() => {
    const h = e => { if (e.key === "Escape") onClose() }
    window.addEventListener("keydown", h)
    return () => window.removeEventListener("keydown", h)
  }, [onClose])
  return (
    <div className="prop-lightbox" onClick={onClose}>
      <div className="prop-lightbox__inner" onClick={e=>e.stopPropagation()}>
        <button className="prop-lightbox__close" onClick={onClose}>✕</button>
        <div className="prop-lightbox__nombre">{hotel.nombre} · {hotel.zona}</div>
        <div className="prop-lightbox__frame">
          {hotel.fotos.map((src,i)=>(
            <img key={i} src={src} alt={`${hotel.nombre} ${i+1}`}
              width="400" height="300"
              style={{objectFit:"cover", width:"100%", height:"100%"}}
              loading="lazy"
              className={"prop-lightbox__img"+(i===idx?" visible":"")} />
          ))}
          {hotel.fotos.length > 1 && (
            <>
              <button className="prop-lightbox__nav prop-lightbox__nav--prev"
                onClick={()=>setIdx(i=>i===0?hotel.fotos.length-1:i-1)}>‹</button>
              <button className="prop-lightbox__nav prop-lightbox__nav--next"
                onClick={()=>setIdx(i=>i===hotel.fotos.length-1?0:i+1)}>›</button>
              <div className="prop-lightbox__dots">
                {hotel.fotos.map((_,i)=>(
                  <button key={i} className={"prop-lightbox__dot"+(i===idx?" active":"")} onClick={()=>setIdx(i)}/>
                ))}
              </div>
            </>
          )}
        </div>
        <div className="prop-lightbox__desc">{hotel.desc}</div>
        {hotel.amenities?.length > 0 && (
          <div className="prop-lightbox__amenities">
            {hotel.amenities.map((a,i)=><span key={i} className="prop-amenity">{a}</span>)}
          </div>
        )}
      </div>
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Card hotel (sección info + selección fusionada)
// ═══════════════════════════════════════════════════════════
function CardHotel({ hotel, seleccionado, onSeleccionar, noches }) {
  const [open, setOpen] = useState(false)
  const subtotal = noches && hotel.precioPorNoche ? hotel.precioPorNoche * noches : null
  return (
    <>
      <div
        className={"prop-hotel-card" + (seleccionado ? " prop-hotel-card--sel" : "")}
        onClick={() => setOpen(true)} role="button" tabIndex={0}
      >
        <div className="prop-hotel-card__foto-wrap">
          <img src={hotel.fotos[0]} alt={hotel.nombre}
            className="prop-hotel-card__foto"
            width="400" height="240"
            loading="lazy"
            onError={e=>{e.target.style.background="#111827"}} />
          {seleccionado && (
            <div className="prop-hotel-card__sel-overlay">✓ Seleccionada</div>
          )}
          <div className="prop-hotel-card__ver">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M15 3h6v6M14 10l6.1-6.1M9 21H3v-6M10 14l-6.1 6.1"/>
            </svg>
            Ver fotos
          </div>
          {hotel.precioPorNoche && (
            <div className="prop-hotel-card__precio-badge">
              <span className="prop-hotel-card__precio-val">${hotel.precioPorNoche}</span>
              <span className="prop-hotel-card__precio-sub">USD/noche · 2 pax</span>
            </div>
          )}
        </div>
        <div className="prop-hotel-card__info">
          <div className="prop-hotel-card__nombre">{hotel.nombre}</div>
          <div className="prop-hotel-card__zona">📍 {hotel.zona}</div>
          <div className="prop-hotel-card__desc">{hotel.desc}</div>
          {hotel.amenities?.length > 0 && (
            <div className="prop-hotel-card__amenities">
              {hotel.amenities.map((a,i)=><span key={i} className="prop-amenity">{a}</span>)}
            </div>
          )}
          {/* Fila precio + botón seleccionar — solo si viene con callback */}
          {onSeleccionar && (
            <div className="prop-hotel-card__footer">
              {subtotal && (
                <div className="prop-hotel-card__subtotal">
                  = <span className="val-usd">${subtotal.toLocaleString("es-AR")} USD</span>
                  <span className="prop-hotel-card__sub-noches"> · {noches} noches</span>
                </div>
              )}
              <button
                className={"prop-hotel-card__sel-btn" + (seleccionado ? " active" : "")}
                onClick={e => { e.stopPropagation(); onSeleccionar(hotel) }}
              >
                {seleccionado ? "✓ Seleccionada" : "Seleccionar para mi paquete"}
              </button>
            </div>
          )}
        </div>
      </div>
      {open && <Lightbox hotel={hotel} onClose={()=>setOpen(false)} />}
    </>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Explorá posadas + selección fusionada
// ═══════════════════════════════════════════════════════════
function SelectorTier({ destino, hotelSel, seleccionarHotel, noches }) {
  const tiers = HOTELES[destino.id] || []
  const [tierActivo, setTierActivo] = useState(destino.tierDefault)
  const [zonaFiltro, setZonaFiltro] = useState(null)
  const tier = tiers.find(t=>t.id===tierActivo)||tiers[0]
  const esBuzios = destino.id==="rio-buzios"
  const zonasDisponibles = esBuzios
    ? ZONAS_BUZIOS.filter(z=>(tier?.ciudades.find(c=>c.ciudad==="Búzios")?.zonas||[]).includes(z.id))
    : []
  const zonaInfo = ZONAS_BUZIOS.find(z=>z.id===zonaFiltro)

  // Lookup: ciudad del hotel en CALC_HOTELES para conectar con el estado
  function getCiudadDelHotel(nombreHotel) {
    for (const [ciudad, hoteles] of Object.entries(CALC_HOTELES[destino.id]||{})) {
      if (hoteles.find(h=>h.nombre===nombreHotel)) return ciudad
    }
    return null
  }
  function getCalcHotel(nombreHotel) {
    for (const hoteles of Object.values(CALC_HOTELES[destino.id]||{})) {
      const h = hoteles.find(h=>h.nombre===nombreHotel)
      if (h) return h
    }
    return null
  }

  return (
    <div className="prop-tiers">
      <div className="prop-tiers__header">
        <div className="prop-card__label" style={{marginBottom:0}}>🏨 Explorá y elegí tus posadas</div>
        <div className="prop-tiers__header-sub">
          Hacé click en "Seleccionar" en la posada que más te guste · El precio se actualiza automáticamente abajo
        </div>
      </div>
      <div className="prop-tiers__tabs">
        {tiers.map(t=>(
          <button key={t.id} className={"prop-tiers__tab"+(tierActivo===t.id?" active":"")}
            onClick={()=>{setTierActivo(t.id);setZonaFiltro(null)}}>
            <span className="prop-tiers__tab-label">{t.label}</span>
            <span className="prop-tiers__tab-desc">{t.desc}</span>
          </button>
        ))}
      </div>
      {tier && tier.ciudades.map(ciu=>(
        <div key={ciu.ciudad} className="prop-tiers__ciudad">
          <div className="prop-tiers__ciudad-nombre">📍 {ciu.ciudad}</div>
          {esBuzios && ciu.ciudad==="Búzios" && zonasDisponibles.length>1 && (
            <div className="prop-zonas-buzios">
              <div className="prop-zonas-buzios__label">Filtrar por zona:</div>
              <div className="prop-zonas-buzios__btns">
                <button className={"prop-zona-btn"+(!zonaFiltro?" active":"")} onClick={()=>setZonaFiltro(null)}>Todas</button>
                {zonasDisponibles.map(z=>(
                  <button key={z.id} className={"prop-zona-btn"+(zonaFiltro===z.id?" active":"")}
                    onClick={()=>setZonaFiltro(zonaFiltro===z.id?null:z.id)}>{z.label}</button>
                ))}
              </div>
              {zonaInfo && <div className="prop-zonas-buzios__desc"><strong>{zonaInfo.label}:</strong> {zonaInfo.desc}</div>}
            </div>
          )}
          <div className="prop-tiers__hoteles">
            {ciu.hoteles
              .filter(h=>!zonaFiltro||!esBuzios||ciu.ciudad!=="Búzios"||h.zonaId===zonaFiltro)
              .map((h,i)=>{
                const ciudad = getCiudadDelHotel(h.nombre)
                const calcH  = getCalcHotel(h.nombre)
                const seleccionado = ciudad && hotelSel?.[ciudad]?.nombre === h.nombre
                const nochesCity   = ciudad ? (noches?.[ciudad]||0) : 0
                return (
                  <CardHotel key={i} hotel={h}
                    seleccionado={seleccionado}
                    noches={nochesCity > 0 ? nochesCity : null}
                    onSeleccionar={calcH && ciudad
                      ? () => seleccionarHotel(ciudad, calcH)
                      : null
                    }
                  />
                )
              })}
          </div>
        </div>
      ))}
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Carrusel de fotos ambiente
// ═══════════════════════════════════════════════════════════
function CarruselFotos({ destinoId }) {
  const ciudades = Object.keys(FOTOS_AMBIENTE[destinoId]||{})
  const [ciudad, setCiudad] = useState(ciudades[0])
  const [idx, setIdx]       = useState(0)
  const [hover, setHover]   = useState(false)
  const fotos = FOTOS_AMBIENTE[destinoId]?.[ciudad]||[]

  // Auto-avance cada 4 seg — pausa al hover
  useEffect(() => {
    if (hover || fotos.length <= 1) return
    const timer = setInterval(() => {
      setIdx(i => i === fotos.length - 1 ? 0 : i + 1)
    }, 4000)
    return () => clearInterval(timer)
  }, [hover, fotos.length, ciudad])

  const cambiarCiudad = (c) => { setCiudad(c); setIdx(0) }

  return (
    <div className="prop-carrusel">
      <div className="prop-carrusel__tabs">
        {ciudades.map(c=>(
          <button key={c} className={"prop-carrusel__tab"+(ciudad===c?" active":"")}
            onClick={()=>cambiarCiudad(c)}>{c}</button>
        ))}
      </div>
      <div className="prop-carrusel__frame"
        onMouseEnter={()=>setHover(true)}
        onMouseLeave={()=>setHover(false)}>
        {fotos.map((src,i)=>(
          <img key={i} src={src} alt={`${ciudad} ${i+1}`}
            width="800" height="500"
            style={{objectFit:"cover", width:"100%", height:"100%"}}
            className={"prop-carrusel__img"+(i===idx?" visible":"")}
            loading="lazy" onError={e=>{e.target.style.display="none"}} />
        ))}
        <button className="prop-carrusel__btn prop-carrusel__btn--prev"
          onClick={()=>setIdx(i=>i===0?fotos.length-1:i-1)}>‹</button>
        <button className="prop-carrusel__btn prop-carrusel__btn--next"
          onClick={()=>setIdx(i=>i===fotos.length-1?0:i+1)}>›</button>
        <div className="prop-carrusel__label">{ciudad}</div>
        {!hover && fotos.length > 1 && (
          <div key={ciudad+"-"+idx} className="prop-carrusel__progress" />
        )}
        <div className="prop-carrusel__dots">
          {fotos.map((_,i)=>(
            <button key={i} className={"prop-carrusel__dot"+(i===idx?" active":"")} onClick={()=>setIdx(i)}/>
          ))}
        </div>
      </div>
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Flujo del viaje
// ═══════════════════════════════════════════════════════════
function FlujoPasos({ destinoId }) {
  return (
    <div className="prop-flujo">
      {(FLUJO_VIAJE[destinoId]||[]).map((p,i,arr)=>(
        <div key={i} className="prop-flujo__paso">
          <div className="prop-flujo__paso-izq">
            <div className="prop-flujo__icono-wrap"><span>{p.icono}</span></div>
            {i<arr.length-1 && <div className="prop-flujo__linea"/>}
          </div>
          <div className="prop-flujo__texto">
            <div className="prop-flujo__titulo">{p.titulo}</div>
            <div className="prop-flujo__desc">{p.desc}</div>
          </div>
        </div>
      ))}
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Card de puntos
// ═══════════════════════════════════════════════════════════
function CardPuntos({ clienteData, precioDesde }) {
  const [expandida, setExpandida] = useState(false)
  const puntos = ptsCliente(clienteData)
  const descuento = calcularDescuento(puntos)
  const tienePuntos = puntos > 0
  return (
    <div className={"prop-puntos-card"+(tienePuntos?" tiene-puntos":"")}>
      <div className="prop-puntos-card__main">
        <div className="prop-puntos-card__left">
          <span className="prop-puntos-card__star">{tienePuntos?"⭐":"🔘"}</span>
          <div>
            {tienePuntos ? (
              <>
                <div className="prop-puntos-card__titulo">Tenés <strong>{puntos} puntos Low Travel</strong></div>
                <div className="prop-puntos-card__sub">
                  Equivalen a <strong>${descuento} USD de descuento</strong>
                  {" · "}tu precio desde{" "}
                  <span className="prop-puntos-card__precio">${precioDesde-descuento} USD</span> por persona
                </div>
              </>
            ) : (
              <>
                <div className="prop-puntos-card__titulo prop-puntos-card__titulo--vacio">Todavía no tenés puntos acumulados</div>
                <div className="prop-puntos-card__sub">Se suman automáticamente con cada viaje. ¡El primer viaje ya te da puntos!</div>
              </>
            )}
          </div>
        </div>
        <button className="prop-puntos-card__toggle" onClick={()=>setExpandida(p=>!p)}>
          {expandida?"Ocultar ▲":"Ver descuentos ▼"}
        </button>
      </div>
      {expandida && (
        <div className="prop-puntos-card__tabla">
          <div className="prop-puntos-card__tabla-titulo">Tabla de canje · Puntos → Descuento USD</div>
          <div className="prop-puntos-card__tabla-grid">
            {CANJE.map(c=>{
              const ok=puntos>=c.puntos
              return (
                <div key={c.puntos} className={"prop-puntos-card__fila"+(ok?" alcanzado":"")}>
                  <span className="prop-puntos-card__pts">⭐ {c.puntos} pts</span>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{color:"#4b5563",flexShrink:0}}><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                  <span className="prop-puntos-card__desc">${c.descuento} USD</span>
                  {ok && <span className="prop-puntos-card__check">✓ Disponible</span>}
                </div>
              )
            })}
          </div>
          <div className="prop-puntos-card__nota">Los descuentos se acumulan. Con 350 pts ahorrás $100 USD.</div>
        </div>
      )}
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// CALCULADOR — Hook compartido de estado
// ═══════════════════════════════════════════════════════════
function useCalcState(destino) {
  const ciudades = Object.keys(CALC_HOTELES[destino.id])
  const [ciudadOrigen, setCiudadOrigen] = useState("Buenos Aires")
  const [noches, setNoches] = useState({...NOCHES_DEF[destino.id]})
  const [hotelSel, setHotelSel] = useState(()=>{
    const s={}; ciudades.forEach(c=>{s[c]=CALC_HOTELES[destino.id][c][0]}); return s
  })
  const [dolarMEP, setDolarMEP] = useState(null)
  const [loadingDolar, setLoadingDolar] = useState(true)
  const [dolarFecha, setDolarFecha] = useState(null)
  const [dolarEsCache, setDolarEsCache] = useState(false)

  useEffect(()=>{
    setNoches({...NOCHES_DEF[destino.id]})
    const s={}; ciudades.forEach(c=>{s[c]=CALC_HOTELES[destino.id][c][0]}); setHotelSel(s)
    setCiudadOrigen("Buenos Aires")
  },[destino.id])

  useEffect(()=>{
    fetch("https://dolarapi.com/v1/dolares/bolsa")
      .then(r=>r.json())
      .then(d=>{
        setDolarMEP(d.venta)
        setDolarFecha(null)
        setDolarEsCache(false)
        setLoadingDolar(false)
      })
      .catch(async ()=>{
        // Fallback: leer caché de Firestore
        try {
          const snap = await getDoc(doc(db,"config","dolar_mep"))
          if (snap.exists()) {
            const data = snap.data()
            setDolarMEP(data.venta)
            setDolarFecha(data.actualizadoEn?.toDate?.() ?? null)
            setDolarEsCache(true)
          }
        } catch(_) {}
        setLoadingDolar(false)
      })
  },[])

  const totalNoches = ciudades.reduce((s,c)=>s+noches[c],0)
  const cambiarNoches = (ciudad,delta) =>
    setNoches(prev=>({...prev,[ciudad]:Math.max(0,Math.min(10,prev[ciudad]+delta))}))
  const seleccionarHotel = (ciudad, hotel) =>
    setHotelSel(prev=>({...prev,[ciudad]:hotel}))

  return { ciudades, ciudadOrigen, setCiudadOrigen, noches, hotelSel,
           dolarMEP, loadingDolar, dolarFecha, dolarEsCache, totalNoches, cambiarNoches, seleccionarHotel }
}

// ═══════════════════════════════════════════════════════════
// CALCULADOR — Bloque de resultados (compartido)
// ═══════════════════════════════════════════════════════════
function ResultadoCalc({ destino, ciudades, ciudadOrigen, noches, hotelSel, dolarMEP, loadingDolar, dolarFecha, dolarEsCache, clienteData }) {
  const puntos = ptsCliente(clienteData)
  const descuento = puntos>0 ? calcularDescuento(puntos) : 0
  const costoAereos   = AEREOS[destino.id][ciudadOrigen]
  const costoHoteles  = ciudades.reduce((s,c)=>s+hotelSel[c].precioPorNoche*noches[c],0)
  const costoTraslados = TRASLADOS[destino.id]
  const subtotal = costoAereos+costoHoteles+costoTraslados
  const totalFinal = Math.max(0, subtotal-descuento)
  const porPersona = Math.round(totalFinal/2)
  const dolarAgencia = dolarMEP ? +(dolarMEP*1.015).toFixed(2) : null
  const enPesos = dolarAgencia ? Math.round(totalFinal*dolarAgencia) : null

  const hotelLines = ciudades.filter(c=>noches[c]>0)
    .map(c=>`🏨 ${c}: ${hotelSel[c].nombre} (${noches[c]} noches)`).join("\n")
  const wspMsg = encodeURIComponent(
    `Hola Sergio! Armé este paquete en tu web:\n`+
    `📍 Destino: ${destino.nombre}\n`+
    `✈️ Salida desde: ${ciudadOrigen}\n`+
    `${hotelLines}\n`+
    `🚐 Traslados incluidos\n`+
    `💰 Total estimado: $${totalFinal.toLocaleString("es-AR")} USD (2 personas)\n`+
    `¿Podés confirmarme disponibilidad y fechas?`
  )

  return (
    <div className="prop-resultado">
      <div className="prop-resultado__titulo">💰 Desglose del paquete</div>

      {/* Items */}
      <div className="prop-resultado__items">
        <div className="prop-resultado__item">
          <span>✈️ Aéreos desde {ciudadOrigen}</span>
          <span className="val-usd">${costoAereos.toLocaleString("es-AR")} USD</span>
        </div>
        {ciudades.filter(c=>noches[c]>0).map(c=>(
          <div key={c} className="prop-resultado__item">
            <span>🏨 {hotelSel[c].nombre} <span className="detalle">· {noches[c]} noches en {c.split(" ")[0]}</span></span>
            <span className="val-usd">${(hotelSel[c].precioPorNoche*noches[c]).toLocaleString("es-AR")} USD</span>
          </div>
        ))}
        <div className="prop-resultado__item">
          <span>🚐 Traslados (incluidos)</span>
          <span className="val-usd">${costoTraslados.toLocaleString("es-AR")} USD</span>
        </div>
        {puntos > 0 ? (
          <div className="prop-resultado__item prop-resultado__item--descuento">
            <span>⭐ Descuento por puntos ({puntos} pts)</span>
            <span className="val-usd val-descuento">−${descuento} USD</span>
          </div>
        ) : !clienteData && (
          <div className="prop-resultado__item prop-resultado__item--hint">
            <span>🔐 <Link to="/register" className="prop-calc-link">Registrate gratis</Link> para ver tu descuento por puntos</span>
          </div>
        )}
      </div>

      {/* Totales */}
      <div className="prop-resultado__totales">
        <div className="prop-resultado__total-row prop-resultado__total-principal">
          <span>Total para 2 personas</span>
          <span className="val-usd val-total">${totalFinal.toLocaleString("es-AR")} USD</span>
        </div>
        <div className="prop-resultado__total-row">
          <span>Por persona</span>
          <span className="val-usd">${porPersona.toLocaleString("es-AR")} USD</span>
        </div>

        {/* Bloque ARS */}
        <div className="prop-resultado__ars-bloque">
          {loadingDolar ? (
            <div className="prop-resultado__ars-loading">Cargando cotización del dólar...</div>
          ) : enPesos ? (
            <>
              <div className="prop-resultado__ars-valor">~${enPesos.toLocaleString("es-AR")} ARS</div>
              <div className="prop-resultado__ars-sub">Equivalente en pesos para 2 personas</div>
              {/* Bloque dólar bien visible */}
              <div className="prop-resultado__dolar-box">
                <div className="prop-resultado__dolar-icono">💱</div>
                <div>
                  <div className="prop-resultado__dolar-titulo">
                    Dólar de referencia{dolarEsCache ? " (último conocido)" : " hoy"}
                  </div>
                  <div className="prop-resultado__dolar-valor">
                    ${dolarAgencia?.toLocaleString("es-AR",{minimumFractionDigits:2})} ARS
                    <span className="prop-resultado__dolar-tag">MEP + 1%</span>
                  </div>
                  {dolarEsCache && dolarFecha && (
                    <div className="prop-resultado__dolar-cache-aviso">
                      ⚠️ Cotización no disponible en este momento. Último valor:{" "}
                      {dolarFecha.toLocaleDateString("es-AR",{day:"2-digit",month:"2-digit",year:"numeric"})}.
                      El valor final se confirma al momento del pago.
                    </div>
                  )}
                  {!dolarEsCache && (
                    <div className="prop-resultado__dolar-nota">
                      Se actualiza automáticamente. El valor final se confirma al momento del pago.
                    </div>
                  )}
                </div>
              </div>
              <div className="prop-resultado__ars-aviso">
                ⚠️ Valor aproximado. La agencia cobra en dólares o su equivalente en pesos al tipo de cambio MEP vigente al momento del pago.
              </div>
            </>
          ) : (
            <div className="prop-resultado__ars-loading">No se pudo cargar la cotización del dólar.</div>
          )}
        </div>
      </div>

      {/* CTA */}
      <div className="prop-resultado__cta">
        <a href={`https://wa.me/5491125603574?text=${wspMsg}`}
          target="_blank" rel="noreferrer" className="prop-calc__btn-wsp">
          <WspIcon /> Verificar Disponibilidad
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </a>
        <div className="prop-resultado__cta-sub">Sergio recibe el detalle completo y te responde personalmente · Sin compromiso</div>
        <div className="prop-resultado__cta-alt">
          ¿Preferís que Sergio te arme la propuesta?{" "}
          <Link to="/consulta" className="prop-resultado__cta-alt-link">
            Dejá tu consulta acá →
          </Link>
        </div>
      </div>
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// CALCULADOR — Modo SIMPLE (flujo guiado 3 pasos)
// ═══════════════════════════════════════════════════════════
function CalculadorSimple({ destino, clienteData, calcState }) {
  const { ciudades, ciudadOrigen, setCiudadOrigen, noches, hotelSel,
          dolarMEP, loadingDolar, dolarFecha, dolarEsCache, totalNoches, cambiarNoches, seleccionarHotel } = calcState

  const paso1ok = totalNoches >= 7
  const paso2ok = paso1ok && ciudadOrigen

  return (
    <div className="calc-simple">

      {/* PASO 1 — Noches */}
      <div className="calc-simple__paso">
        <div className="calc-simple__paso-header">
          <div className="calc-simple__num">1</div>
          <div>
            <div className="calc-simple__paso-titulo">¿Cuántas noches querés en cada ciudad?</div>
            <div className="calc-simple__paso-sub">Mínimo 7 noches en total · Default recomendado ya aplicado</div>
          </div>
          {paso1ok && <div className="calc-simple__check">✓</div>}
        </div>
        <div className="calc-simple__noches-grid">
          {ciudades.map(ciudad=>(
            <div key={ciudad} className="calc-simple__noche-bloque">
              <div className="calc-simple__noche-ciudad">📍 {ciudad}</div>
              <div className="calc-simple__noche-ctrl">
                <button className="calc-simple__noche-btn"
                  onClick={()=>cambiarNoches(ciudad,-1)} disabled={noches[ciudad]<=0}>−</button>
                <span className="calc-simple__noche-num">{noches[ciudad]}</span>
                <button className="calc-simple__noche-btn"
                  onClick={()=>cambiarNoches(ciudad,+1)} disabled={noches[ciudad]>=10}>+</button>
              </div>
              <div className="calc-simple__noche-label">
                {noches[ciudad]===0 ? "Sin noches" : `${noches[ciudad]} noche${noches[ciudad]>1?"s":""}`}
              </div>
            </div>
          ))}
        </div>
        <div className="calc-simple__noches-total">
          {totalNoches===0 && <span className="calc-simple__aviso">👆 Elegí al menos 7 noches en total para continuar.</span>}
          {totalNoches>0 && totalNoches<7 && <span className="calc-simple__aviso calc-simple__aviso--warn">⚠️ Llevás {totalNoches} noches — faltán {7-totalNoches} más para continuar.</span>}
          {totalNoches>=7 && <span className="calc-simple__aviso calc-simple__aviso--ok">✓ {totalNoches} noches seleccionadas</span>}
        </div>
      </div>

      {/* PASO 2 — Origen (se muestra cuando paso 1 ok) */}
      {paso1ok && (
        <div className="calc-simple__paso">
          <div className="calc-simple__paso-header">
            <div className="calc-simple__num">2</div>
            <div>
              <div className="calc-simple__paso-titulo">¿Desde dónde salís?</div>
              <div className="calc-simple__paso-sub">Precio de aéreos para 2 personas · Carry-on incluido</div>
            </div>
            {paso2ok && <div className="calc-simple__check">✓</div>}
          </div>
          <div className="calc-simple__origenes">
            {Object.entries(AEREOS[destino.id]).map(([ciudad, precio])=>(
              <button key={ciudad}
                className={"calc-simple__origen"+(ciudadOrigen===ciudad?" active":"")}
                onClick={()=>setCiudadOrigen(ciudad)}>
                <span className="calc-simple__origen-ciudad">{ciudad}</span>
                <span className="val-usd calc-simple__origen-precio">${precio.toLocaleString("es-AR")} USD</span>
                <span className="calc-simple__origen-desc">2 personas</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* RESULTADO */}
      {paso2ok && (
        <ResultadoCalc
          destino={destino} ciudades={ciudades.filter(c=>noches[c]>0)}
          ciudadOrigen={ciudadOrigen} noches={noches} hotelSel={hotelSel}
          dolarMEP={dolarMEP} loadingDolar={loadingDolar}
          dolarFecha={dolarFecha} dolarEsCache={dolarEsCache}
          clienteData={clienteData}
        />
      )}
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// CALCULADOR — Modo DETALLADO (vista completa)
// ═══════════════════════════════════════════════════════════
function CalculadorDetallado({ destino, clienteData, calcState }) {
  const { ciudades, ciudadOrigen, setCiudadOrigen, noches, hotelSel,
          dolarMEP, loadingDolar, dolarFecha, dolarEsCache, totalNoches, cambiarNoches, seleccionarHotel } = calcState

  return (
    <div className="calc-detallado">
      {/* Paso 1: Origen */}
      <div className="prop-calc__seccion">
        <div className="prop-calc__paso-num">1</div>
        <div className="prop-calc__paso-content">
          <div className="prop-calc__paso-titulo">¿Desde dónde salís?</div>
          <div className="prop-calc__paso-sub">Precio de aéreos para 2 personas · Carry-on incluido</div>
          <div className="prop-calc__origenes">
            {Object.entries(AEREOS[destino.id]).map(([ciudad,precio])=>(
              <button key={ciudad}
                className={"prop-calc__origen"+(ciudadOrigen===ciudad?" active":"")}
                onClick={()=>setCiudadOrigen(ciudad)}>
                <span className="prop-calc__origen-ciudad">{ciudad}</span>
                <span className="val-usd prop-calc__origen-precio">${precio.toLocaleString("es-AR")} USD</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Noches por ciudad — Paso 2 del detallado */}
      <div className="prop-calc__seccion">
        <div className="prop-calc__paso-num">2</div>
        <div className="prop-calc__paso-content">
          <div className="prop-calc__paso-titulo">¿Cuántas noches en cada ciudad?</div>
          <div className="prop-calc__paso-sub">Mínimo 7 noches en total · La posada se elige arriba en "Explorá las posadas"</div>
          <div className="prop-calc__ciudades-grid">
            {ciudades.map(ciudad=>(
              <div key={ciudad} className="prop-calc__ciudad-bloque">
                <div className="prop-calc__ciudad-bloque-nombre">📍 {ciudad}</div>
                {hotelSel[ciudad] && (
                  <div className="prop-calc__hotel-elegido">
                    <span className="prop-calc__hotel-elegido-label">Posada elegida</span>
                    <span className="prop-calc__hotel-elegido-nombre">✓ {hotelSel[ciudad].nombre}</span>
                    <span className="val-usd prop-calc__hotel-elegido-precio">${hotelSel[ciudad].precioPorNoche}/noche</span>
                  </div>
                )}
                <div className="prop-calc__noches">
                  <div className="prop-calc__noches-label">Noches en {ciudad.split(" ")[0]}</div>
                  <div className="prop-calc__noches-ctrl">
                    <button className="prop-calc__noches-btn"
                      onClick={()=>cambiarNoches(ciudad,-1)} disabled={noches[ciudad]<=0}>−</button>
                    <span className="prop-calc__noches-valor">{noches[ciudad]}</span>
                    <button className="prop-calc__noches-btn"
                      onClick={()=>cambiarNoches(ciudad,+1)} disabled={noches[ciudad]>=10}>+</button>
                  </div>
                  <div className="val-usd prop-calc__noches-total">
                    {noches[ciudad]>0 ? `$${(hotelSel[ciudad].precioPorNoche*noches[ciudad]).toLocaleString("es-AR")} USD` : "Sin noches"}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {totalNoches>0 && totalNoches<7 && (
            <div className="prop-calc__warning">⚠️ El mínimo es 7 noches en total. Llevás {totalNoches} — sumá {7-totalNoches} más.</div>
          )}
        </div>
      </div>

      {/* Resultado */}
      {totalNoches >= 7 && (
        <ResultadoCalc
          destino={destino} ciudades={ciudades.filter(c=>noches[c]>0)}
          ciudadOrigen={ciudadOrigen} noches={noches} hotelSel={hotelSel}
          dolarMEP={dolarMEP} loadingDolar={loadingDolar}
          dolarFecha={dolarFecha} dolarEsCache={dolarEsCache}
          clienteData={clienteData}
        />
      )}
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// CALCULADOR — Wrapper con toggle
// ═══════════════════════════════════════════════════════════
function CalculadorPaquete({ destino, clienteData, calcState }) {
  const [modoDetallado, setModoDetallado] = useState(false)

  return (
    <div className="prop-calc">
      <div className="prop-calc__head">
        <div className="prop-calc__head-left">
          <div className="prop-calc__icono">🧮</div>
          <div>
            <div className="prop-calc__titulo">Calculá el precio de tu paquete</div>
            <div className="prop-calc__subtitulo">Precio exacto para 2 personas · Las posadas se eligen arriba · Temporada baja</div>
          </div>
        </div>
        <div className="prop-calc__toggle-wrap">
          <button
            className={"prop-calc__toggle-btn"+(!modoDetallado?" active":"")}
            onClick={()=>setModoDetallado(false)}>
            🧭 Modo simple
          </button>
          <button
            className={"prop-calc__toggle-btn"+(modoDetallado?" active":"")}
            onClick={()=>setModoDetallado(true)}>
            ⚙️ Modo detallado
          </button>
        </div>
      </div>

      <div className="prop-calc__body">
        {modoDetallado
          ? <CalculadorDetallado destino={destino} clienteData={clienteData} calcState={calcState} />
          : <CalculadorSimple    destino={destino} clienteData={clienteData} calcState={calcState} />
        }
      </div>
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Card completa de destino
// ═══════════════════════════════════════════════════════════
function CardDestino({ destino, clienteData }) {
  // Estado compartido entre SelectorTier y CalculadorPaquete
  const calcState = useCalcState(destino)
  const { hotelSel, seleccionarHotel, noches } = calcState

  return (
    <div className="prop-card">
      {/* Encabezado */}
      <div className="prop-card__head">
        <div className="prop-card__head-left">
          <div className="prop-card__region">{destino.emoji} {destino.region}</div>
          <h2 className="prop-card__nombre">{destino.nombre}</h2>
          <p className="prop-card__desc">{destino.descripcion}</p>
        </div>
        <div className="prop-card__precio-box">
          <div className="prop-card__desde">Desde</div>
          <div className="prop-card__precio">${destino.precioDesde}<span className="prop-card__moneda"> USD</span></div>
          <div className="prop-card__precio-sub">por persona · temporada baja</div>
          <div className="prop-card__temporada">📅 {destino.temporada}</div>
        </div>
      </div>

      {/* Puntos */}
      <CardPuntos clienteData={clienteData} precioDesde={destino.precioDesde} />

      {/* Video + Flujo */}
      <div className="prop-card__video-flujo">
        <div>
          <div className="prop-card__label">🎬 Video del destino</div>
          <VideoShort videoId={destino.videoId} />
        </div>
        <div>
          <div className="prop-card__label">🗓️ Cómo se vive este viaje</div>
          <FlujoPasos destinoId={destino.id} />
        </div>
      </div>

      {/* Incluye */}
      <div className="prop-incluye">
        <div className="prop-card__label">✅ El paquete incluye</div>
        <div className="prop-incluye__grid">
          {INCLUYE.map((item,i)=>(
            <div key={i} className="prop-incluye__item">
              <div className="prop-incluye__icono">{item.icono}</div>
              <div>
                <div className="prop-incluye__label">{item.label}</div>
                <div className="prop-incluye__sub">{item.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Carrusel */}
      <div className="prop-card__label" style={{marginBottom:10}}>📸 Conocé los destinos</div>
      <CarruselFotos destinoId={destino.id} />

      {/* Posadas — explorar + seleccionar en un solo lugar */}
      <SelectorTier
        destino={destino}
        hotelSel={hotelSel}
        seleccionarHotel={seleccionarHotel}
        noches={noches}
      />

      {/* Calculador — recibe el mismo estado */}
      <CalculadorPaquete destino={destino} clienteData={clienteData} calcState={calcState} />
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// COMPONENTE — Por qué Sergio
// ═══════════════════════════════════════════════════════════
function PorQueSergio() {
  const items = [
    { icono:"🧭", titulo:"Asesoría real, de persona a persona", desc:"Hablás con Sergio, que recorrió cada destino. No con un bot ni un formulario." },
    { icono:"💰", titulo:"El precio que acordamos es el que pagás", desc:"Sin sorpresas ni letras chicas. Impuestos incluidos desde el primer número." },
    { icono:"🛟", titulo:"Presente durante todo el viaje", desc:"Si algo sale mal, Sergio está disponible 24hs para resolverlo al instante." },
  ]
  return (
    <div className="prop-porq">
      <h3 className="prop-porq__titulo">¿Por qué viajar con Sergio?</h3>
      <div className="prop-porq__grid">
        {items.map((item,i)=>(
          <div key={i} className="prop-porq__card">
            <div className="prop-porq__icono">{item.icono}</div>
            <div className="prop-porq__card-titulo">{item.titulo}</div>
            <div className="prop-porq__card-desc">{item.desc}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

// ═══════════════════════════════════════════════════════════
// PÁGINA PRINCIPAL
// ═══════════════════════════════════════════════════════════
export default function Propuestas() {
  const { userData, clienteData } = useAuth()
  const [destinoActivo, setDestinoActivo] = useState("rio-buzios")
  const destino = DESTINOS.find(d=>d.id===destinoActivo)
  const puntos = ptsCliente(clienteData)

  return (
    <div className="propuestas-page">

      {/* Hero */}
      <div className="prop-hero">
        <div className="prop-hero__bg"/>
        <div className="container prop-hero__inner">
          <div className="prop-hero__badge">✈️ Temporada baja 2026</div>
          <h1 className="prop-hero__titulo">Viajes a <span>Brasil</span><br/>con Sergio</h1>
          <p className="prop-hero__sub">Destinos que no encontrás en Despegar. Precios reales, cupos propios y Sergio con vos en cada paso.</p>
          {puntos > 0 && (
            <div className="prop-hero__puntos">
              ⭐ Tenés <strong>{puntos} puntos</strong>{" → "}
              <strong>${calcularDescuento(puntos)} USD de descuento</strong> disponibles
            </div>
          )}
        </div>
      </div>

      <div className="container">

        {/* Selector de destino */}
        <div className="prop-selector-wrap">
          <div className="prop-selector__label">Elegí tu destino</div>
          <div className="prop-selector">
            {DESTINOS.map(d=>(
              <button key={d.id}
                className={"prop-selector__btn"+(destinoActivo===d.id?" active":"")}
                onClick={()=>setDestinoActivo(d.id)}>
                <span className="prop-selector__emoji">{d.emoji}</span>
                <div className="prop-selector__info">
                  <span className="prop-selector__nombre">{d.nombre}</span>
                  <span className="prop-selector__desde">desde ${d.precioDesde} USD · por persona</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Barra de urgencia */}
        {destino && <BarraUrgencia destino={destino} />}

        {/* Card destino */}
        {destino && <CardDestino key={destino.id} destino={destino} clienteData={clienteData} />}

        <PorQueSergio />

        <div className="prop-cta-final">
          <div className="prop-cta-final__titulo">¿Querés armar algo a medida?</div>
          <div className="prop-cta-final__sub">Sergio puede combinar destinos, fechas y presupuesto para diseñar tu viaje ideal.</div>
          <a href="https://wa.me/5491125603574?text=Hola Sergio! Quiero consultar sobre un viaje a medida."
            target="_blank" rel="noreferrer" className="prop-cta-final__btn">
            💬 Consultar a Sergio
          </a>
        </div>

      </div>
    </div>
  )
}